var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Watch, Utils, PropertyConverters, Components } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
export class PacemAdaptedIterativeElement extends Components.PacemElement {
    constructor() {
        super(...arguments);
        this.index = 0;
    }
    isCloseTo(ndx, focusndx) {
        if (Utils.isNull(this.datasource) || this.datasource.length == 0)
            return false;
        return /*this.adapter.isClose(ndx) ||*/ this._isCloseToCore(ndx, focusndx, this.datasource.length);
    }
    isPrevious(ndx, focusndx) {
        if (Utils.isNull(this.datasource) || this.datasource.length == 0)
            return false;
        return /*this.adapter.isPrevious(ndx) ||*/ this._isPreviousCore(ndx, focusndx, this.datasource.length);
    }
    isNext(ndx, focusndx) {
        if (Utils.isNull(this.datasource) || this.datasource.length == 0)
            return false;
        return /*this.adapter.isNext(ndx) ||*/ this._isNextCore(ndx, focusndx, this.datasource.length);
    }
    _isNextCore(ndx, focusndx, count) {
        return ((focusndx + 1) % count) === ndx;
    }
    _isPreviousCore(ndx, focusndx, count) {
        return ((focusndx - 1 + count) % count) === ndx;
    }
    _isCloseToCore(ndx, focusndx, count) {
        return (((focusndx + count) % count) == ((ndx + count) % count))
            || this._isNextCore(ndx, focusndx, count) || this._isPreviousCore(ndx, focusndx, count);
    }
}
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemAdaptedIterativeElement.prototype, "index", void 0);
__decorate([
    Watch()
], PacemAdaptedIterativeElement.prototype, "datasource", void 0);
